import type { AppMessages } from '../../types';

export const app: AppMessages = {
  common: {
    loading: 'Chargement...',
    saving: 'Enregistrement...',
    save: 'Enregistrer',
    back: 'Retour',
    error: 'Erreur',
    notSet: 'Non défini',
    user: 'Utilisateur',
    system: 'Système',
    copied: 'Copié !',
    copy: 'Copier',
    cancel: 'Annuler',
    creating: 'Création...',
    processing: 'Traitement...',
    you: 'Vous',
    stars: 'Stars',
    seeAll: 'Tout voir',
    filter: 'Filtrer',
    amount: 'Montant',
    date: 'Date',
    details: 'Détails',
    mustBeLoggedIn: 'Vous devez être connecté',
    daysShort: 'j',
    hoursShort: 'h',
    minutesShort: 'min',
    justNow: 'À l\'instant',
    noTitle: 'Sans titre',
    payment: 'paiement',
    payments: 'paiements',
  },
  layout: {
    dashboard: 'Tableau de bord',
    invoices: 'Factures',
    clients: 'Clients',
    ledger: 'Ledger',
    withdraws: 'Retraits',
    redirects: 'Redirections',
    settings: 'Paramètres',
    admin: 'Admin',
    profile: 'Profil',
    logout: 'Déconnexion',
    tonConfigured: 'TON configuré',
    configureTon: 'Configurer TON',
    tonNotConfigured: 'Adresse TON non configurée',
    active: 'Actif',
    walletConnect: 'Connecter le wallet',
    walletTitle: 'Connectez votre wallet TON',
    walletSubtitle: 'Saisissez l’adresse TON qui recevra vos retraits.',
    walletConnectedTitle: 'Wallet connecté',
    walletConnectedSubtitle: 'Vos retraits seront envoyés à cette adresse.',
    walletCurrentAddress: 'Adresse connectée',
    walletAddressLabel: 'Adresse TON',
    walletHint: 'Format user-friendly (EQ… / UQ…) ou brut (0:…) accepté.',
    walletInvalidAddress: 'Adresse TON invalide',
    walletUpdate: 'Mettre à jour l’adresse',
    walletChangeAddress: 'Changer d’adresse',
    walletDisconnect: 'Déconnecter',
    walletDisconnectConfirmTitle: 'Déconnecter le wallet ?',
    walletDisconnectConfirmBody: 'Vous ne pourrez plus demander de retrait tant qu’une nouvelle adresse n’est pas connectée.',
    walletSaved: 'Wallet connecté avec succès',
    walletDisconnected: 'Wallet déconnecté',
    newPaymentLink: 'Nouveau lien de paiement',
    openBot: 'Bot Telegram',
    helpCenter: 'Centre d’aide',
  },
  login: {
    seoTitle: 'Connexion | Plateforme de paiement Telegram Stars',
    seoDescription: 'Connectez-vous à votre compte Telegram Stars Payment Platform',
    signIn: 'Connexion',
    signUp: 'Inscription',
    email: 'Email',
    password: 'Mot de passe',
    displayNameOptional: 'Nom d\'affichage (optionnel)',
    displayNamePlaceholder: 'Votre nom',
    emailPlaceholder: 'votre@email.com',
    signInButton: 'Se connecter',
    signUpButton: 'S\'inscrire',
    signInWithGoogle: 'Se connecter avec Google',
    or: 'OU',
    welcome: 'Bienvenue',
    subtitle: 'Connectez-vous ou créez un compte pour commencer',
    minPasswordHint: 'Minimum 6 caractères',
    tipTelegram: '💡 Astuce : vous pouvez lier votre compte Telegram dans les paramètres après l\'inscription',
    continueWithTelegram: 'Continuer avec Telegram',
    telegramAuthError: 'Connexion Telegram échouée. Réessayez.',
    featureInstant: 'Création de compte instantanée',
    featureManage: 'Gérez vos paiements Telegram Stars',
    featureWithdraw: 'Retirez vos fonds en TON',
    emailRequired: 'Veuillez entrer votre email',
    emailInvalid: 'Format d\'email invalide',
    passwordRequired: 'Veuillez entrer votre mot de passe',
    passwordRequiredSignup: 'Veuillez entrer un mot de passe',
    passwordMinLength: 'Le mot de passe doit contenir au moins 6 caractères',
    genericError: 'Une erreur est survenue',
    recaptchaFailed: 'Échec de la vérification reCAPTCHA. Veuillez réessayer.',
    invalidCredentials: 'Email ou mot de passe incorrect. Si vous n\'avez pas encore de compte, créez-en un dans l\'onglet « Inscription ».',
    wrongPassword: 'Mot de passe incorrect. Vérifiez votre mot de passe.',
    tooManyAttempts: 'Trop de tentatives. Veuillez réessayer plus tard.',
    accountDisabled: 'Ce compte a été désactivé. Contactez le support.',
    authNotEnabled: 'L\'authentification email/mot de passe n\'est pas activée. Vérifiez la configuration Firebase.',
    emailInUse: 'Cet email est déjà utilisé. Connectez-vous avec cet email.',
    googleAuthError: 'Une erreur est survenue lors de l\'authentification Google',
    popupClosed: 'La fenêtre a été fermée. Veuillez réessayer.',
    popupBlocked: 'La fenêtre a été bloquée. Autorisez les popups et réessayez.',
    popupCancelled: 'Une seule demande de popup est autorisée à la fois.',
  },
  dashboard: {
    loading: 'Chargement du tableau de bord...',
    overallSummary: 'Résumé global',
    lastMonth: 'Mois dernier',
    lastWeek: 'Semaine dernière',
    lastYear: 'Année dernière',
    balance: 'Solde',
    available: 'Disponible',
    totalEarned: 'Total gagné',
    fromLastMonth: 'par rapport au mois dernier',
    recentPayments: 'Paiements récents',
    last7days: '7 derniers jours',
    last30days: '30 derniers jours',
    last14days: '14 derniers jours',
    applyPeriod: 'Appliquer',
    vsPreviousPeriod: 'vs période précédente',
    quickActions: 'Actions rapides',
    createLink: 'Créer un lien',
    createLinkDesc: 'Générer un nouveau lien de paiement',
    withdraw: 'Retirer',
    withdrawDesc: 'Retirez vos Stars en TON',
    invoices: 'Factures',
    invoicesDesc: 'Voir l\'historique des paiements',
    ledger: 'Ledger',
    ledgerDesc: 'Voir toutes les transactions',
    recentActivity: 'Activité récente',
    noRecentActivity: 'Aucune activité récente',
    mostRecent: 'Plus récents',
    noRecentInvoices: 'Aucune facture récente',
    allInvoices: 'Toutes les factures',
    paymentReceived: 'Paiement reçu : {title}',
    withdrawalRequested: 'Retrait demandé : {amount} {suffix}',
    transaction: 'Transaction : {amount} {suffix}',
    invoiceLabel: 'Facture #{id}',
    failedLoadBalance: 'Échec du chargement du solde',
    chartAmount: 'Montant',
  },
  invoices: {
    loading: 'Chargement...',
    allInvoices: 'Toutes les factures',
    paid: 'Payées',
    sent: 'Envoyées',
    created: 'Créées',
    expired: 'Expirées',
    filter: 'Filtrer',
    createInvoice: '+ Créer une facture',
    noInvoices: 'Aucune facture trouvée',
    relatedTo: 'Lié à :',
    paymentMode: 'Paiement {mode}',
    copyLink: 'Copier le lien',
    copyLinkTitle: 'Copier le lien de facture',
    linkNotAvailable: 'Lien de facture non disponible',
    linkCopied: 'Lien de facture copié dans le presse-papiers !',
    copyFailed: 'Échec de la copie du lien',
    failedLoad: 'Échec du chargement des factures',
    statusPaid: 'payée',
    statusSent: 'envoyée',
    statusCreated: 'créée',
    statusExpired: 'expirée',
    typeSingleUse: 'usage unique',
    typeRecurring: 'récurrent',
  },
  createInvoice: {
    back: 'Retour',
    title: 'Créer un lien de paiement',
    subtitle: 'Générez un nouveau lien de paiement en quelques secondes',
    successTitle: 'Lien de paiement créé !',
    successSubtitle: 'Votre lien de paiement est prêt à être partagé',
    paymentLink: 'Lien de paiement :',
    integrationTitle: 'Intégrer ce lien sur votre site',
    integrationDesc: 'Notre bot Telegram vous guide pas à pas (API, bouton HTML, redirects).',
    openTutorial: 'Ouvrir le tutoriel',
    testLink: 'Tester le lien',
    viewInvoices: 'Voir mes factures',
    createNew: 'Créer un nouveau lien',
    shareTelegram: 'Partager sur Telegram',
    paymentMode: 'Mode de paiement',
    modeStars: 'Stars',
    modeEur: 'EUR (€)',
    modeUsd: 'USD ($)',
    amountInteger: 'Montant (entier)',
    amountDecimal: 'Montant (décimal)',
    amountRequired: 'Veuillez entrer un montant',
    amountIntegerError: 'Le montant doit être un entier supérieur à 0',
    amountNoDecimals: 'Le montant en Stars doit être un entier (pas de décimales)',
    amountMustBeInteger: 'Le montant en Stars doit être un entier',
    amountGreaterThanZero: 'Le montant doit être supérieur à 0',
    titleOptional: 'Titre (optionnel)',
    titlePlaceholder: 'Titre du paiement (ex. : Paiement pour services)',
    descriptionOptional: 'Description (optionnelle)',
    descriptionPlaceholder: 'Description détaillée du paiement...',
    singleUse: 'Lien à usage unique',
    singleUseTooltip: 'Si activé, ce lien ne peut être utilisé qu\'une seule fois. Une fois payé, il ne sera plus valide.',
    createLink: 'Créer le lien',
    cancel: 'Annuler',
    invalidAmount: 'Montant invalide',
    starsMustBeInteger: 'Le montant doit être un entier pour les Stars',
    createError: 'Erreur lors de la création de la facture',
  },
  ledger: {
    title: 'Ledger',
    typeColumn: 'Type',
    description: 'Historique complet de toutes vos transactions',
    loading: 'Chargement...',
    noEntries: 'Aucune transaction pour le moment.',
    typePayment: 'Paiement',
    typeFee: 'Frais',
    typeNetPayment: 'Paiement net',
    typeWithdrawal: 'Retrait',
    typeAdjustment: 'Ajustement',
    amountStars: 'Montant (Stars)',
    invoiceDetail: 'Facture : {title} ({amount} Stars)',
    paidBy: 'Payé par : {payer}',
    payerId: '(ID : {id})',
    withdrawDetail: 'Retrait : {amount} Stars (Statut : {status})',
    failedLoad: 'Échec du chargement du ledger',
  },
  withdraws: {
    title: 'Mes demandes de retrait',
    newRequest: '+ Nouvelle demande',
    totalLedger: 'Total ledger',
    available: 'Disponible',
    pendingWithdrawals: 'Retraits en attente',
    hold21days: 'Blocage 21 jours',
    payoutNote: 'Les paiements sont traités manuellement par un admin. Des frais de 3 % s\'appliquent au retrait.',
    forecastTitle: 'Prévision de retrait',
    loadingForecast: 'Chargement de la prévision...',
    noForecast: 'Aucune date de retrait à venir',
    paymentsCount: '({count} paiements)',
    noRequests: 'Aucune demande de retrait pour le moment.',
    createFirst: 'Créer votre première demande',
    amount: 'Montant :',
    destination: 'Destination :',
    processedOn: 'Traité le :',
    externalRef: 'Référence externe :',
    errorLabel: 'Erreur :',
    rejectionReason: 'Motif de rejet :',
    failedLoad: 'Échec du chargement des retraits',
    loading: 'Chargement...',
  },
  createWithdraw: {
    title: 'Demander un retrait',
    balanceSource: 'Solde (source : ledger backend)',
    available: 'Disponible : {amount} Stars',
    pending: 'Retraits en attente : {amount} Stars',
    waiting: 'Blocage 21 jours : {amount} Stars',
    minAndFee: 'Retrait minimum : {min} Stars · Frais plateforme : 3 % au paiement (traitement manuel)',
    amountLabel: 'Montant (Stars)',
    minPlaceholder: 'Minimum : {min}',
    feeHint: 'Brut : {gross} Stars · Frais (3 %) : {fee} Stars · Vous recevez : {net} Stars',
    useRegistered: 'Utiliser mon adresse TON enregistrée',
    registeredAddress: 'Adresse enregistrée :',
    tonDestination: 'Adresse TON de destination',
    tonPlaceholder: 'EQAbc123...',
    tonFormatHint: 'Format : EQ... ou 0:... (base64 ou hex)',
    createRequest: 'Créer la demande',
    cancel: 'Annuler',
    creating: 'Création...',
    insufficientBalance: '⚠️ Solde insuffisant pour un retrait (minimum : {min} Stars)',
    amountMustBeInteger: 'Le montant doit être un entier positif',
    createError: 'Erreur lors de la création de la demande de retrait',
  },
  redirects: {
    title: 'Liens de redirection',
    description: 'Créez des liens courts qui redirigent vers une URL de votre choix. Partager le lien /r/votre-slug enverra vos visiteurs vers l\'URL configurée.',
    newRedirect: 'Nouvelle redirection',
    clicks: 'clics',
    unique: 'uniques',
    links: 'liens',
    modalTitle: 'Nouvelle redirection',
    slugLabel: 'Slug (identifiant du lien)',
    slugRequired: 'Champ requis',
    slugPattern: 'Lettres, chiffres, tirets et underscores uniquement',
    slugMax: 'Max 64 caractères',
    slugReserved: 'Ce slug est réservé. Choisissez un autre.',
    slugPlaceholder: 'ex : mon-site',
    urlLabel: 'URL de destination',
    urlInvalid: 'URL invalide',
    urlHttpOnly: 'Seules les URLs http et https sont acceptées.',
    urlTooLong: 'URL trop longue (max 2048 caractères).',
    urlPlaceholder: 'https://example.com/page',
    createButton: 'Créer la redirection',
    loading: 'Chargement…',
    empty: 'Aucune redirection. Cliquez sur « Nouvelle redirection » pour en créer une.',
    copyLink: 'Copier le lien',
    linkCopied: 'Lien copié',
    deleteTitle: 'Supprimer cette redirection ?',
    yes: 'Oui',
    no: 'Non',
    delete: 'Supprimer',
    totalClicks: 'Total clics',
    uniqueClicks: 'Clics uniques',
    avgClicks: 'Moy. clics/visiteur',
    loadError: 'Erreur lors du chargement',
    createSuccess: 'Lien de redirection créé',
    createError: 'Erreur lors de la création',
    deleteSuccess: 'Redirection supprimée',
    deleteError: 'Erreur lors de la suppression',
  },
  adminWithdraws: {
    title: 'Administration - Demandes de retrait',
    filterByStatus: 'Filtrer par statut :',
    all: 'Tous',
    noRequests: 'Aucune demande pour ce statut.',
    agent: 'Agent :',
    amount: 'Montant :',
    destination: 'Destination :',
    processedOn: 'Traité le :',
    externalRef: 'Réf. externe :',
    errorLabel: 'Erreur :',
    reason: 'Motif :',
    approve: '✓ Approuver',
    reject: '✗ Rejeter',
    markPaid: '✓ Marquer payé',
    markFailed: '✗ Marquer échoué',
    approveConfirm: 'Approuver cette demande de retrait ?',
    rejectPrompt: 'Motif de rejet :',
    markPaidPrompt: 'Référence de paiement externe (obligatoire — hash tx TON, ref bancaire, etc.) :',
    markPaidRequired: 'externalRef est requis pour confirmer un paiement manuel.',
    markFailedPrompt: 'Message d\'erreur :',
    approveError: 'Erreur lors de l\'approbation',
    rejectError: 'Erreur lors du rejet',
    updateError: 'Erreur lors de la mise à jour',
    failedLoad: 'Échec du chargement des retraits',
    notAuthenticated: 'Non authentifié',
    operationFailed: 'Opération échouée',
    loading: 'Chargement...',
  },
  redirectResolve: {
    missingSlug: 'Slug manquant',
    invalidLink: 'Lien invalide',
    notFound: 'Lien introuvable',
    notFoundTitle: 'Lien introuvable',
    redirecting: 'Redirection en cours...',
    redirectTitle: 'Redirection',
  },
  errorBoundary: {
    title: 'Une erreur est survenue',
    subtitle: 'Désolé, quelque chose s\'est mal passé. Veuillez réessayer.',
    goHome: 'Retour à l\'accueil',
    reload: 'Recharger la page',
    devDetails: 'Détails de l\'erreur (dev uniquement) :',
  },
  table: {
    search: 'Rechercher',
    sort: 'Trier',
    filter: 'Filtrer',
    open: 'Ouvrir',
    count: 'Nombre',
    empty: 'Aucun résultat',
    clearSort: 'Supprimer le tri',
    ascending: 'Croissant',
    descending: 'Décroissant',
    viewTable: 'Table',
    properties: 'Propriétés',
  },
  invoicesTable: {
    colTitle: 'Nom',
    colDescription: 'Description',
    colStatus: 'Statut',
    colType: 'Type',
    colAmount: 'Prix',
    colPayments: 'Paiements',
    colCreated: 'Créée le',
    colLink: 'Lien de paiement',
    colMode: 'Mode',
    detailTitle: 'Lien de paiement',
    openLink: 'Ouvrir dans Telegram',
  },
  clients: {
    title: 'Clients',
    subtitle: 'Toutes les personnes qui ont payé un de vos liens, avec montants et statut.',
    viewClients: 'Clients',
    viewPurchases: 'Achats',
    colClient: 'Client',
    colUsername: 'Pseudo',
    colTelegramId: 'ID Telegram',
    colPurchases: 'Achats',
    colTotal: 'Total dépensé',
    colLastPurchase: 'Dernier achat',
    colLastProduct: 'Dernier produit',
    colStatus: 'Statut',
    colProduct: 'Produit',
    colPrice: 'Prix',
    colDate: 'Date',
    statusNew: 'Nouveau',
    statusReturning: 'Fidèle',
    statusVip: 'VIP',
    statusPaid: 'Payé',
    anonymous: 'Acheteur anonyme',
    noClients: 'Aucun client pour le moment — partagez un lien de paiement pour votre première vente.',
    noPurchases: 'Aucun achat pour le moment.',
    failedLoad: 'Échec du chargement des clients',
    purchasesOf: 'Achats',
    kpiClients: 'Clients',
    kpiPurchases: 'Achats',
    kpiRevenue: 'Chiffre d\'affaires',
    kpiAverage: 'Panier moyen',
  },
  projects: {
    all: 'Tous les projets',
    newProject: 'Nouveau projet',
    createTitle: 'Nouveau projet',
    editTitle: 'Modifier le projet',
    name: 'Nom',
    namePlaceholder: 'Ex. Coaching janvier',
    invoices: 'Factures',
    invoicesHint: 'Cochez les factures à rattacher à ce projet.',
    searchInvoices: 'Rechercher une facture',
    noInvoices: 'Aucune facture pour le moment.',
    noMatch: 'Aucune facture ne correspond.',
    create: 'Créer le projet',
    save: 'Enregistrer',
    delete: 'Supprimer',
    confirmDelete: 'Confirmer la suppression',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    failed: 'Impossible d’enregistrer le projet',
    nameRequired: 'Donnez un nom au projet',
    emptyList: 'Aucun projet',
    loadingInvoices: 'Chargement des factures...',
    selectedCount: '{count} sélectionnée(s)',
  },
  adminUsers: {
    menuLabel: 'Utilisateurs',
    menuWithdraws: 'Retraits (admin)',
    viewAll: 'Tous',
    viewActive: 'Actifs (7 j)',
    viewInactive: 'Inactifs (14 j+)',
    viewNoTelegram: 'Sans Telegram',
    viewNoLink: 'Aucun lien créé',
    viewEmailed: 'Relancés',
    colUser: 'Utilisateur',
    colStatus: 'Statut',
    colTelegram: 'Telegram',
    colLinks: 'Liens',
    colRevenue: 'Encaissé',
    colLastSignIn: 'Dernière connexion',
    colLastActivity: 'Dernière action',
    colSignedUp: 'Inscrit le',
    colEmails: 'Relances',
    statusActive: 'Actif',
    statusInactive: 'Inactif',
    statusNew: 'Nouveau',
    statusDisabled: 'Désactivé',
    linked: 'Lié',
    notLinked: 'Non lié',
    never: 'Jamais',
    noEmail: 'Pas d\'email',
    kpiUsers: 'Utilisateurs',
    kpiActive7d: 'Actifs 7 j',
    kpiInactive: 'Inactifs',
    kpiRevenue: 'Encaissé total',
    loginAs: 'Se connecter en tant que',
    loginAsConfirmTitle: 'Ouvrir une session en tant que cet utilisateur ?',
    loginAsConfirm: 'Vous verrez l\'application exactement comme lui. Toutes vos actions seront journalisées comme faites par un admin. Un bandeau vous permettra de revenir sur votre compte.',
    loginAsStarted: 'Session ouverte en tant que {name}',
    loginAsError: 'Impossible d\'ouvrir la session',
    sendEmail: 'Relancer par mail',
    emailTitle: 'Relancer {name}',
    emailTemplate: 'Modèle',
    emailSubject: 'Objet',
    emailMessage: 'Message',
    emailSend: 'Envoyer',
    emailSent: 'Email envoyé à {email}',
    emailError: 'Échec de l\'envoi',
    emailNotConfigured: 'L\'envoi d\'emails n\'est pas configuré sur le serveur (SMTP_PASS ou RESEND_API_KEY manquant).',
    emailNoAddress: 'Cet utilisateur n\'a pas d\'adresse email.',
    emailTitleBulk: 'Relancer {count} utilisateurs',
    emailSentBulk: '{sent} e-mails envoyés',
    emailSentPartial: '{sent} envoyés, {failed} échecs',
    emailSelectSend: 'Envoyer un mail',
    emailSelected: '{count} sélectionnés',
    emailTagsHint: 'Chaque destinataire reçoit sa propre version. Balises : {name}, {email}, {appUrl}, {bot}.',
    emailTagsLabel: 'Insérer',
    templateCustom: 'Message libre',
    templateInactive: 'Relance inactivité',
    templateNoLink: 'Aucun lien de paiement créé',
    templateNoTelegram: 'Telegram non lié',
    templateUnpaid: 'Liens en attente de paiement',
    tabActivity: 'Activité',
    tabInvoices: 'Liens',
    tabPayments: 'Paiements',
    tabEmails: 'Relances',
    activityEmpty: 'Aucune action enregistrée pour le moment.',
    invoicesEmpty: 'Aucun lien de paiement.',
    paymentsEmpty: 'Aucun paiement reçu.',
    emailsEmpty: 'Aucune relance envoyée.',
    byAdmin: 'par admin',
    profile: 'Profil',
    userId: 'ID utilisateur',
    tonAddress: 'Adresse TON',
    bannerTitle: 'Session admin — connecté en tant que {name}',
    bannerHint: 'Vos actions sont journalisées comme faites par un admin.',
    bannerExit: 'Revenir sur mon compte',
    bannerRestored: 'Retour sur votre compte admin',
    bannerExpired: 'Session admin expirée : reconnectez-vous.',
    refresh: 'Actualiser',
    sendTelegram: 'Relancer sur Telegram',
    telegramTitle: 'Relancer {name} sur Telegram',
    telegramSent: 'Message Telegram envoyé',
    telegramError: 'Échec de l\'envoi Telegram',
    telegramNotLinked: 'Cet utilisateur n\'a pas lié son compte Telegram.',
    telegramHint: 'Envoyé par le bot, avec les boutons d\'ouverture de l\'app. L\'utilisateur doit avoir fait /start sur le bot.',
    channelEmail: 'Email',
    channelTelegram: 'Telegram',
  },
};

export const settingsApp = {
  eyebrow: 'PARAMÈTRES',
  profile: 'Profil',
  email: 'Email',
  telegramId: 'ID Telegram',
  notLinked: 'Non lié',
  linking: 'Liaison...',
  linkTelegram: 'Lier mon compte Telegram',
  openFromTelegram: '⚠️ Ouvrez cette page depuis Telegram pour lier votre compte',
  displayName: 'Nom d\'affichage',
  displayNameHint: 'Le nom d\'affichage est défini lors de la création du compte',
  withdrawal: 'Retrait',
  tonAddress: 'Adresse TON de destination',
  tonAddressPlaceholder: 'EQAbc123... ou 0:...',
  tonAddressHint: 'Cette adresse sera utilisée par défaut pour vos retraits',
  tonUpdated: 'Adresse TON mise à jour avec succès',
  about: 'À propos',
  commission: 'Commission plateforme :',
  commissionValue: '3 % sur chaque paiement',
  minWithdrawal: 'Retrait minimum :',
  minWithdrawalValue: '100 Stars',
  starsCurrency: 'Devise Stars :',
  starsCurrencyValue: 'XTR',
  telegramWebAppNotAvailable: 'Telegram WebApp non disponible. Ouvrez cette page depuis Telegram.',
  telegramUserDataNotAvailable: 'Données utilisateur Telegram non disponibles.',
  telegramLinked: 'Compte Telegram lié avec succès !',
  linkTelegramError: 'Erreur lors de la liaison du compte Telegram',
  updateError: 'Erreur lors de la mise à jour',
  mustBeLoggedIn: 'Vous devez être connecté',
};
